import {createContext} from "react";
import IndicatorValueDto from "@/models/interfaces/dtos/indicators/indicator-value-dto";

export type IndicatorMap = Record<string, IndicatorValueDto[]>;

export interface IndicatorsContextProps {
    typeIndicator: string;
    setTypeIndicator: (type: string) => void;
    projectsIndicators: IndicatorMap;
    setIndicatorsForProject: (projetId: string, indicators: IndicatorValueDto[]) => void;
}

export const IndicatorsContext = createContext<IndicatorsContextProps | undefined>(undefined);